module.exports = __webpack_public_path__ + "img/gauage.e648fada.svg";